/*
 * @Description: 
 * @Author: Rabbiter
 * @Date: 2023-03-26 15:27:05
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    baseApi: process.env.VUE_APP_FILE_API || "http://localhost:8080",
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
